import styles from './StatusBadge.module.css';

const MAP = {
  'Approved':        styles.approved,
  'Pending review':  styles.pending,
  'Declined':        styles.declined,
  'Pending':         styles.pending,
  'Rejected':        styles.rejected,
  'Open':            styles.open,
  'Assigned':        styles.assigned,
  'Completed':       styles.completed,
  'Released':        styles.released,
  'Disputed':        styles.disputed,
  'Flagged':         styles.flagged,
  'Closed':          styles.completed,
  'In transit':      styles.inTransit,
  'Awaiting finance': styles.awaitFinance,
  'Escrow locked':    styles.escrowLocked,
  'Paid':             styles.paid,
  'Cleared':          styles.paid,
  'Won':              styles.won,
  'Lost':             styles.lost,
  'Delivered':        styles.completed,
};

export default function StatusBadge({ status }) {
  return <span className={`${styles.badge} ${MAP[status] || styles.pending}`}>{status}</span>;
}
